<div fxLayout="row" fxLayoutAlign="center center" fxFlex="grow">
  <button class="action-btn" mat-icon-button (click)="open()" matTooltip="Search">
    <mat-icon>search</mat-icon>
  </button>
  <mat-form-field class="search" [class.search-open]="isOpen" fxFlex="auto">
    <mat-label>Search&hellip;</mat-label>
    <input #input (blur)="close()" autocomplete="off" matInput>
  </mat-form-field>
</div>
